'use client';

import {createContext, useContext} from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({value, children}) => {
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);